import { atom } from 'jotai';

export const isFeedbackModalOpenAtom = atom(false);
export const usePendoFeedbackAtom = atom(false);
